import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Role } from '../models/role';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  private url_list_role = ''
  private url_create_role = '';
  private url_update_role = '';
  private url_delete_role = '';



  constructor(private http: HttpClient, private configService: AppConfigService) {
    this.url_list_role = this.configService.apiUrl + '/configuration/user/getAll/role-master/';
    this.url_create_role = this.configService.apiUrl + '/configuration/user/create/role-master';
    this.url_update_role = this.configService.apiUrl + '/configuration/user/update/role-master';
    this.url_delete_role = this.configService.apiUrl + '/configuration/user/delete/role-master/';
  }

  getAllRoleMaster(): Observable<any> {
    return this.http.get<any>(this.url_list_role + true);
  }

  createRoleMaster(role: Role): Observable<any> {
    return this.http.post<any>(this.url_create_role, role);
  }

  updateRoleMaster(role: Role): Observable<any> {
    return this.http.put<any>(this.url_update_role, role);
  }

  deleteRoleMaster(functionCode: string) {
    return this.http.delete<any>(this.url_delete_role + functionCode);
  }


}
